<template>
  <v-container class="pa-0" fluid>
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1">
      {{ $t('Paieška') }}
    </h1>
    <div class="pt-4">
      <v-card outlined>
        <!-- form  -->
        <v-card-text>
          <v-row class="mb-0 pb-0">
            <!-- 'action_type', // Veiksmo tipas -->
            <!-- classifiers['action-types'] -->
            <v-col class="pb-0" cols="12" md="12">
              <el-autocomplete
                @change="changeActionType()"
                required
                :items="sortedList"
                itemvalue="value"
                itemtext="text"
                label="Išrašo tipas"
                tooltip="Ireg. Pagrindinis. Paieška. Paieška. Išrašo tipas"
                v-model="formData.action_type"
                validateKey="action_type"
                key="action_type"
                longText
                inFragments
                lock-search
                highest-level
              />
            </v-col>
            <v-col class="pb-0" cols="12" md="12">
              <el-textarea
                label="Duomenų naudojimo tikslas"
                tooltip="Ireg. Pagrindinis. Paieška. Paieška. Duomenų naudojimo tikslas"
                v-model="formData.purpose"
                :maxlength="2000"
                required
              />
            </v-col>
            <v-col class="pb-0" cols="12" md="3">
              <el-autocomplete
                required
                :items="enumsClassifiers.docLanguage"
                enums
                itemvalue="value"
                itemtext="text"
                tooltip="Ireg. Pagrindinis. Paieška. Paieška. Išrašo dokumento kalba"
                label="Išrašo dokumento kalba"
                v-model="formData.docLanguage"
              />
            </v-col>

            <template v-for="item in activeFields">
              <!-- 'pp_code', // Prokūros identifikavimo kodas -->
              <v-col
                :key="item"
                v-if="checkItem(item, 'pp_code')"
                class="pb-0"
                cols="12"
                md="6"
                lg="3"
              >
                <el-text-field
                  :required="checkItemReq('pp_code')"
                  :disabled="checkItemDis('pp_code')"
                  label="Prokūros identifikavimo kodas"
                  tooltip="Ireg. Pagrindinis. Paieška. Paieška. Prokūros identifikavimo kodas"
                  v-model="formData.mandate_code"
                  validateKey="pp_code"
                  key="pp_code"
                  :cMask="10"
                />
              </v-col>
              <!-- 'mandate_code', // Įgaliojimo identifikavimo kodas -->
              <v-col
                :key="item"
                v-if="checkItem(item, 'mandate_code')"
                class="pb-0"
                cols="12"
                md="6"
                lg="3"
              >
                <el-text-field
                  :required="checkItemReq('mandate_code')"
                  :disabled="checkItemDis('mandate_code')"
                  label="Įgaliojimo identifikavimo kodas"
                  tooltip="Ireg. Pagrindinis. Paieška. Paieška. Įgaliojimo identifikavimo kodas"
                  v-model="formData.mandate_code"
                  validateKey="mandate_code"
                  key="mandate_code"
                  :cMask="10"
                />
              </v-col>
              <!-- 'notarial_code', // Notarinio registro numeris -->
              <v-col
                :key="item"
                v-if="checkItem(item, 'notarial_code')"
                class="pb-0"
                cols="12"
                md="6"
                lg="3"
              >
                <el-text-field
                  :required="checkItemReq('notarial_code')"
                  :disabled="checkItemDis('notarial_code')"
                  label="Notarinio registro numeris"
                  tooltip="Ireg. Pagrindinis. Paieška. Paieška. Notarinio registro numeris"
                  v-model="formData.notarial_code"
                  validateKey="notarial_code"
                  key="notarial_code"
                  :maxlength="20"
                />
              </v-col>
              <!-- 'iltu_code', // Fiz ILTU kodas -->
              <v-col
                :key="item"
                v-if="checkItem(item, 'iltu_code')"
                class="pb-0"
                cols="12"
                md="6"
                lg="3"
              >
                <el-text-field
                  :required="checkItemReq('iltu_code')"
                  :disabled="checkItemDis('iltu_code')"
                  label="ILTU kodas"
                  tooltip="Ireg. Pagrindinis. Paieška. Paieška. ILTU kodas"
                  v-model="formData.iltu_code"
                  validateKey="iltu_code"
                  key="iltu_code"
                  :maxlength="20"
                />
              </v-col>
              <!-- 'fiz_code', // Fiz asmens kodas (AK) -->
              <v-col
                :key="item"
                v-if="checkItem(item, 'fiz_code')"
                class="pb-0"
                cols="12"
                md="6"
                lg="3"
              >
                <el-text-field
                  :required="checkItemReq('fiz_code')"
                  :disabled="checkItemDis('fiz_code')"
                  label="Asmens kodas (AK)"
                  tooltip="Ireg. Pagrindinis. Paieška. Paieška. Asmens kodas (AK)"
                  v-model="formData.fiz_code"
                  validateKey="fiz_code"
                  key="fiz_code"
                  :cMask="11"
                />
              </v-col>
              <!-- 'birth_date', // Fiz gimimo data -->
              <v-col
                :key="item"
                v-if="checkItem(item, 'birth_date')"
                class="pb-0"
                cols="12"
                md="6"
                lg="3"
              >
                <el-date-picker
                  :required="checkItemReq('birth_date')"
                  :disabled="checkItemDis('birth_date')"
                  label="Gimimo data"
                  tooltip="Ireg. Pagrindinis. Paieška. Paieška. Gimimo data"
                  v-model="formData.birth_date"
                  pastDates
                  validateKey="UZS_birth_date"
                  key="UZS_birth_date"
                />
              </v-col>
              <!-- 'name', // Fiz vardas -->
              <v-col
                :key="item"
                v-if="checkItem(item, 'name')"
                class="pb-0"
                cols="12"
                md="6"
                lg="3"
              >
                <el-text-field
                  :required="checkItemReq('name')"
                  :disabled="checkItemDis('name')"
                  label="Vardas"
                  tooltip="Ireg. Pagrindinis. Paieška. Paieška. Vardas"
                  v-model="formData.name"
                  validateKey="name"
                  key="name"
                  :maxlength="100"
                />
              </v-col>
              <!-- 'lastname', // Fiz pavarde -->
              <v-col
                :key="item"
                v-if="checkItem(item, 'lastname')"
                class="pb-0"
                cols="12"
                md="6"
                lg="3"
              >
                <el-text-field
                  :required="checkItemReq('lastname')"
                  :disabled="checkItemDis('lastname')"
                  label="Pavardė"
                  tooltip="Ireg. Pagrindinis. Paieška. Paieška. Pavardė"
                  v-model="formData.lastname"
                  validateKey="lastname"
                  key="lastname"
                  :maxlength="100"
                />
              </v-col>
              <!-- 'jur_code', // Jur kodas -->
              <v-col
                :key="item"
                v-if="checkItem(item, 'jur_code')"
                class="pb-0"
                cols="12"
                md="6"
                lg="3"
              >
                <el-text-field
                  :required="checkItemReq('jur_code')"
                  :disabled="checkItemDis('jur_code')"
                  label="Juridinio asmens kodas"
                  tooltip="Ireg. Pagrindinis. Paieška. Paieška. Juridinio asmens kodas"
                  v-model="formData.jur_code"
                  :maxlength="20"
                  validateKey="jur_code"
                  key="jur_code"
                />
              </v-col>
              <!-- 'jur_code_a', // Jur kodas su valstybe -->
              <v-col
                :key="item"
                v-if="checkItem(item, 'jur_code_a')"
                class="pb-0"
                cols="12"
                md="6"
                lg="3"
              >
                <el-text-field
                  :required="checkItemReq('jur_code_a')"
                  :disabled="checkItemDis('jur_code_a')"
                  label="Juridinio asmens kodas"
                  tooltip="Ireg. Pagrindinis. Paieška. Paieška. Juridinio asmens kodas"
                  v-model="formData.jur_code"
                  :maxlength="20"
                  validateKey="jur_code"
                  key="jur_code"
                />
              </v-col>
              <!-- 'country_code', // Jur šalies kodas -->
              <v-col
                :key="item"
                v-if="checkItem(item, 'country_code')"
                class="pb-0"
                cols="12"
                md="6"
                lg="3"
              >
                <el-autocomplete
                  :required="checkItemReq('country_code')"
                  :disabled="checkItemDis('country_code')"
                  :items="classifiers.country"
                  itemvalue="value"
                  itemtext="text"
                  label="Valstybė"
                  tooltip="Ireg. Pagrindinis. Paieška. Paieška. Valstybė"
                  v-model="formData.country_code"
                  validateKey="country_code"
                  key="country_code"
                />
              </v-col>
              <!-- 'action_code', // Paslaugos kodas -->
              <v-col
                :key="item"
                v-if="checkItem(item, 'action_code')"
                class="pb-0"
                cols="12"
                md="6"
                lg="3"
              >
                <el-text-field
                  :required="checkItemReq('action_code')"
                  :disabled="checkItemDis('action_code')"
                  label="Paslaugos / veiksmo kodas"
                  tooltip="Ireg. Pagrindinis. Paieška. Paieška.  Paslaugos ar veiksmo kodas"
                  v-model="formData.action_code"
                  :maxlength="20"
                  validateKey="action_code"
                  key="action_code"
                />
              </v-col>
              <!-- 'period_from', // Periodas nuo -->
              <v-col
                :key="item"
                v-if="checkItem(item, 'period_from')"
                class="pb-0"
                cols="12"
                md="6"
                lg="3"
              >
                <el-date-picker
                  :required="checkItemReq('period_from')"
                  :disabled="checkItemDis('period_from')"
                  label="Periodas nuo"
                  tooltip="Ireg. Pagrindinis. Paieška. Paieška. Periodas nuo"
                  v-model="formData.period_from"
                  validateKey="period_from"
                  key="period_from"
                />
              </v-col>
              <!-- 'period_to', // Periodas iki -->
              <v-col
                :key="item"
                v-if="checkItem(item, 'period_to')"
                class="pb-0"
                cols="12"
                md="6"
                lg="3"
              >
                <el-date-picker
                  :required="checkItemReq('period_to')"
                  :disabled="checkItemDis('period_to')"
                  label="Periodas iki"
                  tooltip="Ireg. Pagrindinis. Paieška. Paieška. Periodas iki"
                  v-model="formData.period_to"
                  validateKey="period_to"
                  key="period_to"
                />
              </v-col>
              <!-- 'service_provider_birth_date', // Paslaugų teikėjo gimimo data -->
              <v-col
                :key="item"
                v-if="checkItem(item, 'service_provider_birth_date')"
                class="pb-0"
                cols="12"
                md="6"
                lg="3"
              >
                <el-date-picker
                  :required="checkItemReq('service_provider_birth_date')"
                  :disabled="checkItemDis('service_provider_birth_date')"
                  label="Paslaugų teikėjo gimimo data"
                  tooltip="Ireg. Pagrindinis. Paieška. Paieška. Paslaugų teikėjo gimimo data"
                  v-model="formData.service_provider_birth_date"
                  validateKey="service_provider_birth_date"
                  key="service_provider_birth_date"
                />
              </v-col>
              <!-- 'service_provider_name', // Paslaugų teikėjo vardas -->
              <v-col
                :key="item"
                v-if="checkItem(item, 'service_provider_name')"
                class="pb-0"
                cols="12"
                md="6"
                lg="3"
              >
                <el-text-field
                  :required="checkItemReq('service_provider_name')"
                  :disabled="checkItemDis('service_provider_name')"
                  label="Paslaugų teikėjo vardas"
                  tooltip="Ireg. Pagrindinis. Paieška. Paieška. Paslaugų teikėjo vardas"
                  v-model="formData.service_provider_name"
                  validateKey="service_provider_name"
                  key="service_provider_name"
                  :maxlength="100"
                />
              </v-col>
              <!-- 'service_provider_lastname', // Paslaugų teikėjo pavardė -->
              <v-col
                :key="item"
                v-if="checkItem(item, 'service_provider_lastname')"
                class="pb-0"
                cols="12"
                md="6"
                lg="3"
              >
                <el-text-field
                  :required="checkItemReq('service_provider_lastname')"
                  :disabled="checkItemDis('service_provider_lastname')"
                  label="Paslaugų teikėjo pavardė"
                  tooltip="Ireg. Pagrindinis. Paieška. Paieška. Paslaugų teikėjo pavardė"
                  v-model="formData.service_provider_lastname"
                  validateKey="service_provider_lastname"
                  key="service_provider_lastname"
                  :maxlength="100"
                />
              </v-col>
              <!-- 'service_jur_code', // Paslaugų teikėjo juridinis kodas -->
              <v-col
                :key="item"
                v-if="checkItem(item, 'service_jur_code')"
                class="pb-0"
                cols="12"
                md="6"
                lg="3"
              >
                <!-- <el-text-field
                  :required="checkItemReq('service_jur_code')"
                  :disabled="checkItemDis('service_jur_code')"
                  label="Paslaugų teikėjo juridinis kodas"
                  tooltip="Ireg. Pagrindinis. Paieška. Paieška. Paslaugų teikėjo juridinis kodas"
                  v-model="formData.service_jur_code"
                  :maxlength="9"
                  validateKey="service_jur_code"
                  key="service_jur_code"
                /> -->
                <el-text-field
                  :required="checkItemReq('service_jur_code')"
                  :disabled="checkItemDis('service_jur_code')"
                  label="Paslaugų teikėjo (JA) kodas"
                  tooltip="Ireg. Pagrindinis. Paieška. Paieška. Paslaugų teikėjo juridinis kodas"
                  v-model="formData.service_jur_code"
                  :maxlength="9"
                  validateKey="service_jur_code"
                  key="service_jur_code"
                />
              </v-col>
              <!-- 'service_fiz_code', // Paslaugų teikėjo Fizinis kodas -->
              <v-col
                :key="item"
                v-if="checkItem(item, 'service_fiz_code')"
                class="pb-0"
                cols="12"
                md="6"
                lg="3"
              >
                <!-- <el-text-field
                  :required="checkItemReq('service_fiz_code')"
                  :disabled="checkItemDis('service_fiz_code')"
                  label="Paslaugų teikėjo kodas"
                  tooltip="Ireg. Pagrindinis. Paieška. Paieška. Paslaugų teikėjo kodas"
                  v-model="formData.service_fiz_code"
                  :maxlength="9"
                  validateKey="service_fiz_code"
                  key="service_fiz_code"
                /> -->
                <el-text-field
                  :required="checkItemReq('service_fiz_code')"
                  :disabled="checkItemDis('service_fiz_code')"
                  label="Paslaugų teikėjo (FA) kodas"
                  tooltip="Ireg. Pagrindinis. Paieška. Paieška. Paslaugų teikėjo kodas"
                  v-model="formData.service_fiz_code"
                  :maxlength="20"
                  validateKey="service_fiz_code"
                  key="service_fiz_code"
                />
              </v-col>
              <!-- 'service_iltu_code', // Paslaugų teikėjo fizinio iltu kodas -->
              <v-col
                :key="item"
                v-if="checkItem(item, 'service_iltu_code')"
                class="pb-0"
                cols="12"
                md="6"
                lg="3"
              >
                <el-text-field
                  :required="checkItemReq('service_iltu_code')"
                  :disabled="checkItemDis('service_iltu_code')"
                  label="Paslaugų teikėjo ILTU kodas"
                  tooltip="Ireg. Pagrindinis. Paieška. Paieška. Paslaugų teikėjo ILTU kodas"
                  v-model="formData.service_iltu_code"
                  :maxlength="20"
                  validateKey="service_iltu_code"
                  key="service_iltu_code"
                />
              </v-col>
              <!-- 'representitive_jur_code', // Įgaliotinio juridinis kodas -->
              <v-col
                :key="item"
                v-if="checkItem(item, 'representitive_jur_code')"
                class="pb-0"
                cols="12"
                md="6"
                lg="3"
              >
                <el-text-field
                  :required="checkItemReq('representitive_jur_code')"
                  :disabled="checkItemDis('representitive_jur_code')"
                  label="Įgaliotinio juridinis kodas"
                  tooltip="Ireg. Pagrindinis. Paieška. Paieška. Įgaliotinio juridinis kodas"
                  v-model="formData.representitive_jur_code"
                  :maxlength="9"
                  validateKey="representitive_jur_code"
                  key="representitive_jur_code"
                />
              </v-col>
              <!-- 'representitive_fiz_code', // Įgaliotinio asmens kodas -->
              <v-col
                :key="item"
                v-if="checkItem(item, 'representitive_fiz_code')"
                class="pb-0"
                cols="12"
                md="6"
                lg="3"
              >
                <el-text-field
                  :required="checkItemReq('representitive_fiz_code')"
                  :disabled="checkItemDis('representitive_fiz_code')"
                  label="Įgaliotinio asmens kodas"
                  tooltip="Ireg. Pagrindinis. Paieška. Paieška. Įgaliotinio asmens kodas"
                  v-model="formData.representitive_fiz_code"
                  validateKey="representitive_fiz_code"
                  key="representitive_fiz_code"
                  :cMask="20"
                />
              </v-col>
              <!-- 'representitive_iltu_code', // Įgaliotinio iltu kodas -->
              <v-col
                :key="item"
                v-if="checkItem(item, 'representitive_iltu_code')"
                class="pb-0"
                cols="12"
                md="6"
                lg="3"
              >
                <el-text-field
                  :required="checkItemReq('representitive_iltu_code')"
                  :disabled="checkItemDis('representitive_iltu_code')"
                  label="Įgaliotinio ILTU kodas"
                  tooltip="Ireg. Pagrindinis. Paieška. Paieška. Įgaliotinio ILTU kodas"
                  v-model="formData.representitive_iltu_code"
                  validateKey="representitive_iltu_code"
                  key="representitive_iltu_code"
                  :maxlength="20"
                />
              </v-col>
            </template>
          </v-row>
          <v-col v-if="this.formData.action_type != 'NULL'" class="ma-0 pa-0 pl-2" cols="12" md="6">
            <v-row class="mb-0 pb-0">
              <v-col class="pb-0 mt-2 pb-0" cols="12" md="12">
                <h2 class="ml-3 mb-2">{{ $t('Duomenų gavėjas') }}</h2>
              </v-col>
              <v-col style="overflow: auto" cols="12" md="12">
                <v-btn-toggle mandatory v-model="recipient.person_type">
                  <v-btn active-class="active-btn-group-item" small value="FIZ" @change="clearRecipient()">
                    <v-icon style="padding-right: 4px">mdi-account</v-icon>
                    <span>{{ $t('Fizinis asmuo') }}</span>
                  </v-btn>
                  <v-btn active-class="active-btn-group-item" small value="JUR" @change="clearRecipient()">
                    <v-icon style="padding-right: 4px">mdi-bank</v-icon>
                    <span>{{ $t('Juridinis asmuo') }}</span>
                  </v-btn>
                </v-btn-toggle>
              </v-col>
              <v-col class="pb-0" cols="12" md="12" lg="6">
                <el-textarea
                  required
                  :label="fizRecipient ? 'Vardas ir pavardė' : 'Pavadinimas'"
                  tooltip="Vieša paieška. Paieška. Pareigos vardas ir pavarde arba pavadinimas"
                  v-model="recipient.fullname"
                  validateKey="recipient_fullname_key"
                  :maxlength="200"
                />
              </v-col>
              <v-col
                style="display: inline-flex"
                class="pb-0"
                cols="12"
                md="12"
                lg="6"
              >
                <el-text-field v-if="!fizRecipient"
                  required
                  label="
                    Juridinio asmens kodas
                  "
                  tooltip="Vieša paieška. Paieška. Asmens arba juridinio asmens kodas"
                  v-model="recipient.jur_code"
                  :maxlength="fizRecipient ? 11 : 20"
                  validateKey="recipient_jur_code_key"
                  key="recipient_jur_code_key"
                />
                <el-button
                  v-if="!fizRecipient"
                  class="ml-1"
                  style="height: 40px"
                  :loading="loading"
                  color="primary"
                  title="Ieškoti"
                  @click.native.stop="searchJurData()"
                />
              </v-col>
              <v-col v-if="fizRecipient" class="pt-0 pb-0" cols="12" >
                <el-radio-group
                  class="mt-0 mb-4"
                  v-model="formData.searchType"
                  :items="searchType"
                  label="searchType"
                  required
                  @change="clearRecipientFields()"
                >
                </el-radio-group>
              </v-col>

              <template v-if="showSearchTypeCode">
                <v-col class="pb-0" cols="12" md="12" lg="6">
                  <el-text-field
                    required
                    label="Asmens kodas"
                    tooltip="Vieša paieška. Paieška. Asmens kodas"
                    v-model="recipient.code"
                    validateKey="FIZ_code"
                    key="FIZ_code"
                    :cMask="11"
                    :length="11"
                  />
                </v-col>
              </template>

              <template v-if="showSearchTypeIltuCode">
                <v-col class="pb-0" cols="12" md="12" lg="6">
                  <el-text-field
                    required
                    label="ILTU kodas"
                    tooltip="Vieša paieška. Paieška. ILTU kodas"
                    v-model="recipient.iltu_code"
                    validateKey="FIZ_iltu_code"
                    key="FIZ_iltu_code"
                    :maxlength="20"
                  />
                </v-col>
              </template>

              <template v-if="showSearchTypedateAnd">
                <v-col class="pb-0" cols="12" md="12" lg="6">
                  <el-date-picker
                    required
                    label="Gimimo data"
                    pastDates
                    tooltip="Vieša paieška. Paieška. Gimimo data"
                    v-model="recipient.birth_date"
                    validateKey="UZS_birth_date"
                    key="UZS_birth_date"
                  />
                </v-col>
              </template>
            </v-row>
          </v-col>
        </v-card-text>
        <v-card-actions>
          <v-row no-gutters>
            <el-button
              title="Ieškoti"
              icon="ieškoti"
              class="mr-2"
              :loading="loading"
              @click.native.stop="search()"
              color="primary"
            />
            <el-button
              title="Išvalyti"
              icon="išvalyti"
              :loading="loading"
              @click.native="clear()"
              color="secondary"
            />
          </v-row>
        </v-card-actions>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import userRole from '@/mixins/userRole'
import Enums from '@/enums'

export default {
  name: 'NewOrder',
  components: {},
  mixins: [userRole],
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      formData: {},
      activeFields: [],
      dataVolume: null,
      pageloading: false,
      loading: false,
      searchBy: null,
      classifiers: {},
      enumsClassifiers: {},
      recipient: {},
    }
  },
  computed: {
    //
    sortedList() {
      if (this.classifiers['action-types']) {
        let list = this.classifiers['action-types']['lt']
        let sorted = { lt: [], en: [] }
        sorted.lt = list.sort(function (a, b) {
          if (a.text < b.text) {
            return -1
          }
          if (a.text > b.text) {
            return 1
          }
          return 0
        })
        return sorted // this.classifiers['action-types']
      } else {
        return {}
      }
    },
    requiredServiceIltuCode() {
      return !this.formData.service_fiz_code && !this.formData.service_jur_code
    },
    requiredServiceFizCode() {
      return !this.formData.service_iltu_code && !this.formData.service_jur_code
    },
    requiredServiceJurCode() {
      return !this.formData.service_fiz_code && !this.formData.service_iltu_code
    },
    //
    requiredRepIltuCode() {
      return (
        !this.formData.representitive_fiz_code &&
        !this.formData.representitive_jur_code
      )
    },
    requiredRepFizCode() {
      return (
        !this.formData.representitive_iltu_code &&
        !this.formData.representitive_jur_code
      )
    },
    requiredRepJurCode() {
      return (
        !this.formData.representitive_fiz_code &&
        !this.formData.representitive_iltu_code
      )
    },
    //
    requiredIltuCode() {
      return !this.formData.fiz_code
    },
    requiredFizCode() {
      return !this.formData.iltu_code
    },
    //
    userRoles() {
      return this.$store.getters.userRole
    },
    fizRecipient() {
      return this.recipient.person_type == 'FIZ'
    },
    showSearchTypeCode() {
      return this.formData.searchType === 'ak' && this.fizRecipient
    },
    showSearchTypeIltuCode() {
      return this.formData.searchType === 'iltu' && this.fizRecipient
    },
    showSearchTypedateAnd() {
      return this.formData.searchType === 'birth-date-and-country' && this.fizRecipient
    },
    searchType() {
      return [
        {
          label: this.$t('Asmens kodas'),
          value: 'ak',
        },
        {
          label: this.$t('ILTU kodas'),
          value: 'iltu',
        },
        {
          label: this.$t('Gimimo data'),
          value: 'birth-date-and-country',
        },
      ]
    },
  },
  beforeDestroy() {},
  created() {
    this.getClassifiers()
  },
  methods: {
    searchJurData() {
      this.loading = true
      let formData = {}
      formData.code = this.recipient.jur_code
      formData.type = 'JUR'
      formData.dataType = 'search_paid'
      formData.lang = this.$store.getters.getSystemLang
      let url = `getJurByAsmCode`
      this.$axios
        .post(url, formData)
        .then((res) => {
          this.recipient.fullname = res.data.person.fullname
          if (res.data.person.adr_text) {
            let adr = res.data.person.adr_text.split(',')
            this.recipient.address = adr[1]
            this.recipient.city = adr[0]
          }
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
          this.loading = false
        })
        .finally(() => {
          this.loading = false
        })
    },
    checkItemDis(key) {
      let actionType =
        this.enumsClassifiers.StatementActionType[this.formData.action_type]
      // null
      if (this.formData.action_type === 'NULL') {
        switch (key) {
          case 'service_jur_code':
            return !!this.formData.service_fiz_code

          case 'service_fiz_code':
            return !!this.formData.service_jur_code
          default:
            break
        }

        return false
      }
      if (
        actionType ===
        'Archyvas_FizGimData_Vardas_Pavarde_PaslaugosKodas_TeikejoFizGimDataVardasPavardeArJurKoda'
      ) {
        switch (key) {
          case 'birth_date':
          case 'name':
          case 'lastname':
            return !!this.formData.jur_code
          // or
          case 'jur_code':
            // case 'action_code':
            return !(
              !this.formData.birth_date &&
              !this.formData.name &&
              !this.formData.lastname
            )
          case 'jur_code_a':
            // case 'action_code':
            return !(
              !this.formData.birth_date &&
              !this.formData.name &&
              !this.formData.lastname
            )

          case 'service_provider_birth_date':
          case 'service_provider_name':
          case 'service_provider_lastname':
            return !!this.formData.service_jur_code
          // or
          case 'service_jur_code':
            return !(
              !this.formData.service_provider_birth_date &&
              !this.formData.service_provider_name &&
              !this.formData.service_provider_lastname
            )

          default:
            break
        }
      }
      if (
        actionType ===
          'Issami_FizGimData_Vardas_Pavarde_PaslaugosKodas_TeikejoFizGimDataVardasPavardeArJurKoda' ||
        actionType ===
          'Santrauka_FizGimData_Vardas_Pavarde_PaslaugosKodas_TeikejoFizGimDataVardasPavardeArJurKoda'
      ) {
        switch (key) {
          case 'birth_date':
          case 'name':
          case 'lastname':
            return !!this.formData.representitive_jur_code
          // or
          case 'representitive_jur_code':
            // case 'action_code':
            return !(
              !this.formData.birth_date &&
              !this.formData.name &&
              !this.formData.lastname
            )

          case 'service_provider_birth_date':
          case 'service_provider_name':
          case 'service_provider_lastname':
            return !!this.formData.service_jur_code
          // or
          case 'service_jur_code':
            return !(
              !this.formData.service_provider_birth_date &&
              !this.formData.service_provider_name &&
              !this.formData.service_provider_lastname
            )

          default:
            break
        }
      }

      // def
      switch (key) {
        case 'iltu_code':
          return !this.requiredIltuCode
        case 'fiz_code':
          return !this.requiredFizCode
        case 'service_jur_code':
          return !this.requiredServiceJurCode
        case 'service_fiz_code':
          return !this.requiredServiceFizCode
        case 'service_iltu_code':
          return !this.requiredServiceIltuCode
        case 'representitive_jur_code':
          return !this.requiredRepJurCode
        case 'representitive_fiz_code':
          return !this.requiredRepFizCode
        case 'representitive_iltu_code':
          return !this.requiredRepIltuCode
        default:
          break
      }

      return false
    },
    checkItemReq(key) {
      let actionType =
        this.enumsClassifiers.StatementActionType[this.formData.action_type]
      if (this.formData.action_type === 'NULL') {
        if (
          this.formData.mandate_code ||
          this.formData.fiz_code ||
          this.formData.iltu_code ||
          this.formData.birth_date ||
          this.formData.name ||
          this.formData.lastname ||
          this.formData.country_code ||
          this.formData.jur_code ||
          this.formData.notarial_code ||
          this.formData.action_code ||
          this.formData.period_from ||
          this.formData.period_to ||
          this.formData.service_fiz_code ||
          this.formData.service_jur_code
        ) {
          return false
        } else {
          return true
        }
      }
      if (
        actionType ===
        'Archyvas_FizGimData_Vardas_Pavarde_PaslaugosKodas_TeikejoFizGimDataVardasPavardeArJurKoda'
      ) {
        switch (key) {
          case 'birth_date':
          case 'name':
          case 'lastname':
            return !this.formData.jur_code
          // or
          case 'jur_code':
            // case 'action_code':
            return (
              !this.formData.birth_date &&
              !this.formData.name &&
              !this.formData.lastname
            )
          case 'jur_code_a':
            return (
              !this.formData.birth_date &&
              !this.formData.name &&
              !this.formData.lastname
            )

          case 'service_provider_birth_date':
          case 'service_provider_name':
          case 'service_provider_lastname':
            return !this.formData.service_jur_code
          // or
          case 'service_jur_code':
            return (
              !this.formData.service_provider_birth_date &&
              !this.formData.service_provider_name &&
              !this.formData.service_provider_lastname
            )

          default:
            break
        }
      }
      if (
        actionType ===
          'Issami_FizGimData_Vardas_Pavarde_PaslaugosKodas_TeikejoFizGimDataVardasPavardeArJurKoda' ||
        actionType ===
          'Santrauka_FizGimData_Vardas_Pavarde_PaslaugosKodas_TeikejoFizGimDataVardasPavardeArJurKoda'
      ) {
        switch (key) {
          case 'birth_date':
          case 'name':
          case 'lastname':
            return !this.formData.representitive_jur_code
          // or
          case 'representitive_jur_code':
            // case 'action_code':
            return (
              !this.formData.birth_date &&
              !this.formData.name &&
              !this.formData.lastname
            )

          case 'service_provider_birth_date':
          case 'service_provider_name':
          case 'service_provider_lastname':
            return !this.formData.service_jur_code
          // or
          case 'service_jur_code':
            return (
              !this.formData.service_provider_birth_date &&
              !this.formData.service_provider_name &&
              !this.formData.service_provider_lastname
            )

          default:
            break
        }
      }
      // def
      switch (key) {
        case 'iltu_code':
          return this.requiredIltuCode
        case 'fiz_code':
          return this.requiredFizCode
        case 'service_jur_code':
          return this.requiredServiceJurCode
        case 'service_fiz_code':
          return this.requiredServiceFizCode
        case 'service_iltu_code':
          return this.requiredServiceIltuCode
        case 'representitive_jur_code':
          return this.requiredRepJurCode
        case 'representitive_fiz_code':
          return this.requiredRepFizCode
        case 'representitive_iltu_code':
          return this.requiredRepIltuCode
        default:
          break
      }

      return true
    },
    changeActionType() {
      let actionType = this.formData.action_type
      let purpose = this.formData.purpose
      this.formData = { action_type: actionType, purpose: purpose }
      this.setFields()
      this.$nextTick(() => {
        this.errors.clear()
        this.$nextTick(() => {
          this.$validator.reset()
        })
      })
    },
    setFields() {
      let actionType =
      this.enumsClassifiers.StatementActionType[this.formData.action_type]
      this.activeFields = []
      let activeFields = []

      switch (actionType) {
        case 'Issami_FizAKarILTU_Notarini':
        case 'IssamiTuriniu_FizAKarILTU_Notarini':
        case 'Santrauka_FizAKarILTU_Notarini':
        case 'Archyvas_FizAKarILTU_Notarini':
        case 'ArchyvasTuriniu_FizAKarILTU_Notarini':
          activeFields.push('fiz_code')
          activeFields.push('iltu_code')
          activeFields.push('notarial_code')
          break

        case 'Issami_FizGimData_Vardas_Pavarde_Notarini':
        case 'IssamiTuriniu_FizGimData_Vardas_Pavarde_Notarini':
        case 'Santrauka_FizGimData_Vardas_Pavarde_Notarini':
        case 'Archyvas_FizGimData_Vardas_Pavarde_Notarini':
        case 'ArchyvasTuriniu_FizGimData_Vardas_Pavarde_Notarini':
          activeFields.push('birth_date')
          activeFields.push('name')
          activeFields.push('lastname')
          activeFields.push('notarial_code')
          break

        case 'Issami_JurKodas_Notarini':
        case 'IssamiTuriniu_JurKodas_Notarini':
        case 'Santrauka_JurKodas_Notarini':
        case 'Archyvas_JurKodas_Notarini':
        case 'ArchyvasTuriniu_JurKodas_Notarini':
          activeFields.push('jur_code')
          activeFields.push('notarial_code')
          break

        case 'Issami_JurKodas_Valstybe_Notarini':
        case 'IssamiTuriniu_JurKodas_Valstybe_Notarini':
        case 'Santrauka_JurKodas_Valstybe_Notarini':
        case 'Archyvas_JurKodas_Valstybe_Notarini':
        case 'ArchyvasTuriniu_JurKodas_Valstybe_Notarini':
          activeFields.push('jur_code_a')
          activeFields.push('country_code')
          activeFields.push('notarial_code')
          break

        case 'Issami_ItpsiKoda_FizAKarILTU':
        case 'Santrauka_ItpsiKoda_FizAKarILTU':
        case 'Archyvas_ItpsiKoda_FizAKarILTU':
          activeFields.push('mandate_code')
          activeFields.push('fiz_code')
          activeFields.push('iltu_code')
          break

        case 'Issami_JurKodas_PPKoda':
        case 'Archyvas_JurKodas_PPKoda':
          activeFields.push('pp_code')
          activeFields.push('jur_code')
          break

        case 'Issami_ItpsiKoda_JurKodas':
        case 'Santrauka_ItpsiKoda_JurKodas':
        case 'Archyvas_ItpsiKoda_JurKodas':
        case 'Issami_JurKodas_PPKoda':
        case 'Archyvas_JurKodas_PPKoda':
          activeFields.push('mandate_code')
          activeFields.push('jur_code')
          break

        case 'Issami_FizGimData_Vardas_Pavarde_ItpsiKoda':
        case 'Santrauka_FizGimData_Vardas_Pavarde_ItpsiKoda':
        case 'Archyvas_FizGimData_Vardas_Pavarde_ItpsiKoda':
          activeFields.push('birth_date')
          activeFields.push('name')
          activeFields.push('lastname')
          activeFields.push('mandate_code')
          break

        case 'Issami_FizAKarILTU_Vardas_Pavarde':
        case 'IssamiTuriniu_FizAKarILTU_Vardas_Pavarde':
        case 'Santrauka_FizAKarILTU_Vardas_Pavarde':
        case 'Archyvas_FizAKarILTU_Vardas_Pavarde':
        case 'ArchyvasTuriniu_FizAKarILTU_Vardas_Pavarde':
          activeFields.push('fiz_code')
          activeFields.push('iltu_code')
          activeFields.push('name')
          activeFields.push('lastname')
          break

        case 'Issami_FizGimData_Vardas_Pavarde':
        case 'IssamiTuriniu_FizGimData_Vardas_Pavarde':
        case 'Santrauka_FizGimData_Vardas_Pavarde':
        case 'Archyvas_FizGimData_Vardas_Pavarde':
        case 'ArchyvasTuriniu_FizGimData_Vardas_Pavarde':
          activeFields.push('birth_date')
          activeFields.push('name')
          activeFields.push('lastname')
          break

        case 'Issami_JurKodas':
        case 'IssamiTuriniu_JurKodas':
        case 'Santrauka_JurKodas':
        case 'Archyvas_JurKodas':
        case 'ArchyvasTuriniu_JurKodas':
          activeFields.push('jur_code')
          break

        case 'Issami_JurKodas_Valstybe':
        case 'IssamiTuriniu_JurKodas_Valstybe':
        case 'Santrauka_JurKodas_Valstybe':
        case 'Archyvas_JurKodas_Valstybe':
        case 'ArchyvasTuriniu_JurKodas_Valstybe':
          activeFields.push('jur_code_a')
          activeFields.push('country_code')
          break

        case 'Archyvas_FizGimData_Vardas_Pavarde_PaslaugosKodas_TeikejoFizGimDataVardasPavardeArJurKoda':
          activeFields.push('birth_date')
          activeFields.push('name')
          activeFields.push('lastname')
          // ar
          activeFields.push('jur_code')

          activeFields.push('action_code')

          activeFields.push('service_provider_birth_date')
          activeFields.push('service_provider_name')
          activeFields.push('service_provider_lastname')
          // ar
          activeFields.push('service_jur_code')

          break

        case 'Issami_IgaliotinioAKarILTUarJurKoda_PaslaugosKodas_TeikejoKodas':
        case 'Santrauka_IgaliotionioAKarILTUarJurKoda_PaslaugosKodas_TeikejoKodas':
          activeFields.push('representitive_jur_code')
          activeFields.push('representitive_fiz_code')
          activeFields.push('representitive_iltu_code')
          activeFields.push('action_code')
          activeFields.push('service_jur_code')
          activeFields.push('service_fiz_code')
          activeFields.push('service_iltu_code')
          break

        case 'Issami_FizGimData_Vardas_Pavarde_PaslaugosKodas_TeikejoFizGimDataVardasPavardeArJurKoda':
        case 'Santrauka_FizGimData_Vardas_Pavarde_PaslaugosKodas_TeikejoFizGimDataVardasPavardeArJurKoda':
          activeFields.push('birth_date')
          activeFields.push('name')
          activeFields.push('lastname')
          // ar
          activeFields.push('representitive_jur_code')
          activeFields.push('action_code')

          activeFields.push('service_provider_birth_date')
          activeFields.push('service_provider_name')
          activeFields.push('service_provider_lastname')
          // ar
          activeFields.push('service_jur_code')
          break

        case 'Issami_ProkuristoAKarILTU_PPKoda':
        case 'Issami_ProkuristoAKarILTU_PPKoda_Turiniu':
          activeFields.push('fiz_code')
          activeFields.push('iltu_code')
          activeFields.push('pp_code')
          break
        case 'Issami_ProkuristoAKarILTU_Vardas_Pavarde_Turiniu':
        case 'Archyvas_ProkuristoAKarILTU_Vardas_Pavarde_Turiniu':
          activeFields.push('fiz_code')
          activeFields.push('iltu_code')
          activeFields.push('name')
          activeFields.push('lastname')
          break
        case 'Issami_ProkuristoGimData_Vardas_Pavarde_Turiniu':
        case 'Archyvas_ProkuristoGimData_Vardas_Pavarde_Turiniu':
          activeFields.push('birth_date')
          activeFields.push('name')
          activeFields.push('lastname')
          break
        case 'Issami_JurKodas_Turiniu':
        case 'Archyvas_JurKodas_Turiniu':
          activeFields.push('jur_code')
          break
        case 'Issami_ProkuristoAKarILTU_Vardas_Pavarde_PPKoda':
        case 'Issami_ProkuristoAKarILTU_Vardas_Pavarde_PPKoda_Turiniu':
          activeFields.push('fiz_code')
          activeFields.push('iltu_code')
          activeFields.push('name')
          activeFields.push('lastname')
          activeFields.push('pp_code')
          break
        case 'Issami_ProkuristoGimData_Vardas_Pavarde_PPKoda':
        case 'Archyvas_ProkuristoGimData_Vardas_Pavarde_PPKoda':
        case 'Issami_ProkuristoGimData_Vardas_Pavarde_PPKoda_Turiniu':
        case 'Archyvas_ProkuristoGimData_Vardas_Pavarde_PPKoda_Turiniu':
          activeFields.push('birth_date')
          activeFields.push('name')
          activeFields.push('lastname')
          activeFields.push('pp_code')
          break
        case 'Issami_JurKodas_PPKoda':
        case 'Archyvas_JurKodas_PPKoda':
        case 'Issami_JurKodas_PPKoda_Turiniu':
        case 'Archyvas_JurKodas_PPKoda_Turiniu':
          activeFields.push('jur_code')
          activeFields.push('pp_code')
          break
        case 'Archyvas_ProkuristoAKarILTU_PPKoda':
        case 'Archyvas_ProkuristoAKarILTU_PPKoda_Turiniu':
          activeFields.push('fiz_code')
          activeFields.push('iltu_code')
          activeFields.push('pp_code')
          break

        case 'Vidinis':
          activeFields.push('mandate_code')
          activeFields.push('fiz_code')
          activeFields.push('iltu_code')
          activeFields.push('birth_date')
          activeFields.push('name')
          activeFields.push('lastname')
          activeFields.push('country_code')
          activeFields.push('jur_code_a')
          activeFields.push('service_jur_code')
          activeFields.push('service_fiz_code')
          activeFields.push('notarial_code')
          activeFields.push('action_code')
          activeFields.push('period_from')
          activeFields.push('period_to')
          break
      }
      this.activeFields = activeFields
    },
    checkItem(item, key) {
      return item === key
    },
    next() {
      this.$router.push({ name: 'searchList' })
    },
    getClassifiers() {
      this.loadDefault = true
      this.enumsClassifiers = Enums
      let requiredClassifiers = { classifiers: ['country', 'action-types'] }
      this.$axios
        .post(`classifiers`, requiredClassifiers)
        .then((res) => {
          this.classifiers = res.data.classifiers
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loadDefault = false
        })
    },
    clearRecipient() {
      this.recipient =  {person_type: this.recipient.person_type}
    },
    clearRecipientFields() {
      let fields = ['code', 'iltu_code', 'birth_date', 'jur_code']
      fields.map((field) => {
        if (this.recipient[field]) {
          this.recipient[field] = ''
        }
      })
    },
    clear() {
      let actionType = this.formData.action_type
      let purpose = this.formData.purpose
      this.formData = { action_type: actionType, purpose: purpose }
      this.recipient = {person_type: this.recipient.person_type};
      this.$nextTick(() => {
        this.errors.clear()
        this.$nextTick(() => {
          this.$validator.reset()
        })
      })
    },

    search() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.loading = true
          let formData = new FormData()
          formData.append('lang', this.$store.getters.getSystemLang)
          formData.append('language', this.formData.docLanguage)
          formData.append('action_type', this.formData.action_type || '')
          formData.append('purpose', this.formData.purpose || '')
          formData.append('mandate_code', this.formData.mandate_code || '')
          formData.append('notarial_code', this.formData.notarial_code || '')
          formData.append('iltu_code', this.formData.iltu_code || '')
          formData.append('fiz_code', this.formData.fiz_code || '')
          formData.append('birth_date', this.formData.birth_date || '')
          formData.append('name', this.formData.name || '')
          formData.append('lastname', this.formData.lastname || '')
          formData.append('jur_code', this.formData.jur_code || '')
          formData.append('country_code', this.formData.country_code || '')
          formData.append('action_code', this.formData.action_code || '')
          formData.append('period_from', this.formData.period_from || '')
          formData.append('period_to', this.formData.period_to || '')
          formData.append(
            'service_provider_birth_date',
            this.formData.service_provider_birth_date || ''
          )
          formData.append(
            'service_provider_name',
            this.formData.service_provider_name || ''
          )
          formData.append(
            'service_provider_lastname',
            this.formData.service_provider_lastname || ''
          )
          formData.append(
            'service_fiz_code',
            this.formData.service_fiz_code || ''
          )
          formData.append(
            'service_iltu_code',
            this.formData.service_iltu_code || ''
          )
          formData.append(
            'service_jur_code',
            this.formData.service_jur_code || ''
          )
          formData.append(
            'representitive_fiz_code',
            this.formData.representitive_fiz_code || ''
          )
          formData.append(
            'representitive_iltu_code',
            this.formData.representitive_iltu_code || ''
          )
          formData.append(
            'representitive_jur_code',
            this.formData.representitive_jur_code || ''
          )
          formData.append('customer_fullname', this.recipient.fullname || '')
          formData.append('customer_code', this.recipient.code || '')
          formData.append('customer_jur_code', this.recipient.jur_code || '')
          formData.append('customer_iltu_code', this.recipient.iltu_code || '')
          formData.append('customer_birth_date', this.recipient.birth_date || '')
          let url = `statement-orders/contract`
          this.$axios
            .post(url, formData)
            .then((res) => {
              this.$root.$emit('DATA_OK_CODE', '000110')
              this.next()
            })
            .catch((err) => {
              this.$root.$emit('DATA_ERROR', err)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          this.$root.$emit('FORMAT_ERROR')
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped></style>
